import { render } from "./Monsters.vue?vue&type=template&id=0cd7c806"
import script from "./Monsters.vue?vue&type=script&lang=js"
export * from "./Monsters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__